(function () {
  "use strict";

  /* Shared store lives in lp-wishlist.js (window.LPWishlist), loaded globally,
     so a heart toggled in any section — or on the wishlist page — stays in sync. */
  function wl() { return window.LPWishlist; }

  /* ---------------------------------------------------------------- */

  function CollectionGrid(root) {
    this.root = root;
    this.sectionId = root.getAttribute("data-section-id");
    this.collectionUrl =
      root.getAttribute("data-collection-url") || location.pathname;
    this.defaultSort = root.getAttribute("data-default-sort") || "";
    this.loading = false;
    root.__cg = this;

    /* One document-level listener per instance for "click outside → close" */
    this._onDocClick = this.handleDocClick.bind(this);
    this._onDocKey = this.handleDocKey.bind(this);
    document.addEventListener("click", this._onDocClick);
    document.addEventListener("keydown", this._onDocKey);

    /* Delegated on the root (survives inner DOM swaps): keep badges, the
       Clear button and the active state live as boxes are ticked. */
    var self = this;
    this.root.addEventListener("change", function (e) {
      if (
        e.target &&
        e.target.matches &&
        e.target.matches('input[type="checkbox"][name], input[name*="price"]')
      ) {
        self.refreshFilterBadges({ liveEdit: true });
      }
    });

    this.bind();
  }

  CollectionGrid.prototype.q = function (sel) {
    return this.root.querySelector(sel);
  };
  CollectionGrid.prototype.qa = function (sel) {
    return Array.prototype.slice.call(this.root.querySelectorAll(sel));
  };

  CollectionGrid.prototype.bind = function () {
    this.syncFilterCheckboxStates();
    this.initHearts();
    this.initFacetToggles();
    this.initDropdowns();

    var self = this;

    var openBtn = this.q("[data-cg-open]");
    var drawer = this.q("[data-cg-drawer]");
    var form = this.q("[data-cg-filter-form]");
    var loadMoreBtn = this.q("[data-cg-load-more]");

    if (openBtn && drawer) {
      openBtn.addEventListener("click", this.openDrawer.bind(this));
      drawer.addEventListener("click", function (e) {
        if (e.target === drawer) self.closeDrawer();
      });
      drawer.addEventListener("cancel", function (e) {
        e.preventDefault();
        self.closeDrawer();
      });
    }

    this.qa("[data-cg-close]").forEach(function (btn) {
      btn.addEventListener("click", self.closeDrawer.bind(self));
    });

    this.qa("[data-cg-clear-all]").forEach(function (btn) {
      btn.addEventListener("click", self.clearAll.bind(self));
    });

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        self.applyFilters();
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener("click", this.loadMore.bind(this));
    }
  };

  /* --- Sync checkbox + price inputs from URL params ------------ */
  CollectionGrid.prototype.syncFilterCheckboxStates = function () {
    try {
      var params = new URLSearchParams(location.search.slice(1));
      var self = this;

      self.qa('input[type="checkbox"][name]').forEach(function (cb) {
        var n = cb.name;
        var v = cb.value;
        var all = params.getAll(n);
        cb.checked = all.indexOf(v) !== -1;
      });

      self
        .qa('input[type="text"][name], input[type="number"][name]')
        .forEach(function (inp) {
          var n = inp.name;
          if (!n) return;
          var fromURL = params.get(n);
          if (fromURL != null && fromURL !== "" && inp.value === "") {
            inp.value = fromURL;
          }
        });

      self.refreshFilterBadges();
    } catch (e) {
      if (window.console)
        console.warn("[cg] syncFilterCheckboxStates failed", e);
    }
  };

  /* --- Refresh per-facet badges + active states after DOM changes ---
     This is the single source of truth for filter UI state. It is driven
     purely by the live DOM (checkboxes already synced from the URL by
     syncFilterCheckboxStates), NOT by server-rendered markup — Shopify
     Liquid cannot read arbitrary query params, so dynamically generated
     filter groups (variant options / metafields) always render with no
     active state. Everything below is recomputed and, where the badge
     element is missing, created. */
  CollectionGrid.prototype.countActive = function (scope) {
    if (!scope) return 0;
    var n = scope.querySelectorAll('input[type="checkbox"]:checked').length;
    scope.querySelectorAll('input[name*="price"]').forEach(function (pi) {
      if (pi && String(pi.value).trim() !== "") n++;
    });
    return n;
  };

  /* Match the Liquid's conditional-render model: the badge element only
     exists while the facet has active values (a bare `hidden` attribute is
     unreliable — `.cg-dd__badge` sets `display`, which wins over it). */
  CollectionGrid.prototype.setFacetBadge = function (host, count) {
    if (!host) return;
    var badge = host.querySelector(":scope > .cg-dd__badge");
    if (count > 0) {
      if (!badge) {
        badge = document.createElement("span");
        badge.className = "cg-dd__badge";
        var caret = host.querySelector(
          ":scope > .cg-dd__caret, :scope > .cg-facet__caret"
        );
        host.insertBefore(badge, caret || null);
      }
      badge.textContent = String(count);
    } else if (badge) {
      badge.remove();
    }
  };

  CollectionGrid.prototype.refreshFilterBadges = function (opts) {
    var self = this;
    /* `liveEdit` = a box was just ticked by the user; don't expand/collapse
       the drawer accordion they're working in, only update the badges. */
    var liveEdit = opts && opts.liveEdit;

    /* On-page filter dropdowns */
    self.qa(".cg-dd--facet").forEach(function (dd) {
      var panel = dd.querySelector("[data-cg-dd-panel]");
      var toggle = dd.querySelector(":scope > .cg-dd__toggle");
      var count = self.countActive(panel);

      dd.classList.toggle("is-active", count > 0);
      self.setFacetBadge(toggle, count);

      var clearBtn = dd.querySelector("[data-cg-dd-clear]");
      if (clearBtn) clearBtn.hidden = count === 0;
    });

    /* Drawer accordions */
    self.qa("[data-cg-facet]").forEach(function (facet) {
      var panel = facet.querySelector(":scope > .cg-facet__panel");
      var summary = facet.querySelector(":scope > [data-cg-facet-toggle]");
      var count = self.countActive(panel || facet);

      if (summary) self.setFacetBadge(summary, count);
      if (!liveEdit) {
        if (summary) {
          summary.setAttribute("aria-expanded", count > 0 ? "true" : "false");
        }
        if (panel) {
          if (count > 0) panel.removeAttribute("hidden");
          else panel.setAttribute("hidden", "");
        }
      }
    });

    /* Totals — Filter button + drawer header */
    var totalActive = self.countActive(self.q("[data-cg-filter-form]"));

    var filterBtnCount = self.q("[data-cg-filter-count]");
    if (filterBtnCount) {
      filterBtnCount.textContent = String(totalActive);
      filterBtnCount.hidden = totalActive === 0;
    }
    var drawerCount = self.q("[data-cg-drawer-count]");
    if (drawerCount) drawerCount.textContent = String(totalActive);
  };

  /* --- Hearts ---------------------------------------------------- */
  CollectionGrid.prototype.initHearts = function () {
    if (!wl()) return;
    var hearts = this.qa("[data-cg-heart]");
    var root = this.root;

    function reflect() {
      Array.prototype.slice.call(root.querySelectorAll("[data-cg-heart]")).forEach(function (btn) {
        var card = btn.closest(".pg-card__inner");
        var id = card && card.getAttribute("data-product-id");
        if (id) btn.setAttribute("aria-pressed", wl().has(id) ? "true" : "false");
      });
    }
    reflect();
    if (!this.root.dataset.cgHeartSub) {
      this.root.dataset.cgHeartSub = "1";
      document.addEventListener("lp:wishlist:change", reflect);
    }

    hearts.forEach(function (btn) {
      if (btn.dataset.cgHeartBound) return;
      btn.dataset.cgHeartBound = "1";

      var card = btn.closest(".pg-card__inner");
      var id = card && card.getAttribute("data-product-id");
      if (!id) return;

      btn.addEventListener("click", function () {
        var next = wl().toggle(id, wl().meta(btn));
        btn.setAttribute("aria-pressed", String(next));
        btn.animate(
          [
            { transform: "scale(1)" },
            { transform: "scale(0.82)" },
            { transform: "scale(1.08)" },
            { transform: "scale(1)" },
          ],
          { duration: 320, easing: "ease" }
        );
      });
    });
  };

  /* --- Drawer facet accordions ------------------------------- */
  CollectionGrid.prototype.initFacetToggles = function () {
    this.qa("[data-cg-facet-toggle]").forEach(function (btn) {
      if (btn.dataset.cgToggleBound) return;
      btn.dataset.cgToggleBound = "1";
      btn.addEventListener("click", function () {
        var expanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!expanded));
        /* Keep the panel's `hidden` attribute in step with aria-expanded —
           it is rendered `hidden` when the facet starts with no active
           values, and CSS `[hidden]` would otherwise keep it closed. */
        var panel = btn.parentElement.querySelector(":scope > .cg-facet__panel");
        if (panel) {
          if (expanded) panel.setAttribute("hidden", "");
          else panel.removeAttribute("hidden");
        }
      });
    });
  };

  /* --- Dropdowns (sort + on-page filters) -------------------- */
  CollectionGrid.prototype.initDropdowns = function () {
    var self = this;

    this.qa("[data-cg-dd]").forEach(function (dd) {
      if (dd.dataset.cgDdBound) return;
      dd.dataset.cgDdBound = "1";

      var toggle = dd.querySelector("[data-cg-dd-toggle]");
      var panel = dd.querySelector("[data-cg-dd-panel]");
      if (!toggle || !panel) return;

      toggle.addEventListener("click", function (e) {
        e.stopPropagation();
        var isOpen = toggle.getAttribute("aria-expanded") === "true";
        self.closeAllDropdowns();
        if (!isOpen) {
          toggle.setAttribute("aria-expanded", "true");
          panel.hidden = false;
        }
      });

      /* Sort option chosen */
      dd.querySelectorAll("[data-cg-sort-opt]").forEach(function (opt) {
        opt.addEventListener("click", function () {
          self.selectSort(opt.getAttribute("data-value"));
        });
      });

      /* On-page filter dropdown: Apply / Clear */
      var applyBtn = dd.querySelector("[data-cg-dd-apply]");
      var clearBtn = dd.querySelector("[data-cg-dd-clear]");
      if (applyBtn) {
        applyBtn.addEventListener("click", function () {
          self.applyDropdown(panel);
        });
      }
      if (clearBtn) {
        clearBtn.addEventListener("click", function () {
          self.clearDropdown(panel);
        });
      }
    });
  };

  CollectionGrid.prototype.closeAllDropdowns = function () {
    this.qa("[data-cg-dd-toggle]").forEach(function (t) {
      t.setAttribute("aria-expanded", "false");
    });
    this.qa("[data-cg-dd-panel]").forEach(function (p) {
      p.hidden = true;
    });
  };

  CollectionGrid.prototype.handleDocClick = function (e) {
    if (!this.root.contains(e.target)) {
      this.closeAllDropdowns();
      return;
    }
    if (!e.target.closest("[data-cg-dd]")) this.closeAllDropdowns();
  };

  CollectionGrid.prototype.handleDocKey = function (e) {
    if (e.key === "Escape") this.closeAllDropdowns();
  };

  /* --- Drawer open / close ----------------------------------- */
  CollectionGrid.prototype.openDrawer = function () {
    var drawer = this.q("[data-cg-drawer]");
    if (!drawer) return;
    if (typeof drawer.showModal === "function") drawer.showModal();
    else drawer.setAttribute("open", "");
    document.documentElement.style.overflow = "hidden";
    requestAnimationFrame(function () {
      drawer.classList.add("is-open");
    });
  };

  CollectionGrid.prototype.closeDrawer = function () {
    var drawer = this.q("[data-cg-drawer]");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    var finish = function () {
      drawer.removeEventListener("transitionend", finish);
      clearTimeout(t);
      if (typeof drawer.close === "function" && drawer.open) drawer.close();
      else drawer.removeAttribute("open");
      document.documentElement.style.overflow = "";
    };
    var t = setTimeout(finish, 360);
    drawer.addEventListener("transitionend", finish);
  };

  /* --- URL helpers ------------------------------------------- */
  CollectionGrid.prototype.baseURL = function () {
    return new URL(this.collectionUrl, location.origin);
  };

  CollectionGrid.prototype.currentSort = function () {
    return (
      new URL(location.href).searchParams.get("sort_by") || this.defaultSort
    );
  };

  /* Params from the drawer form (whole-form re-selection) */
  CollectionGrid.prototype.formParams = function () {
    var form = this.q("[data-cg-filter-form]");
    var params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach(function (value, key) {
        var v = value == null ? "" : String(value).trim();
        if (v === "") return;
        if (key.indexOf("price") !== -1) v = v.replace(/,/g, "");
        if (key === "sort_by") return;
        params.append(key, v);
      });
    }
    var sort = this.currentSort();
    if (sort) params.set("sort_by", sort);
    params.delete("page");
    return params;
  };

  CollectionGrid.prototype.navigate = function (url) {
    this.closeAllDropdowns();
    history.pushState({ cg: true }, "", url.toString());
    this.render(url);
  };

  /* --- Actions --------------------------------------------- */
  CollectionGrid.prototype.applyFilters = function () {
    var url = this.baseURL();
    url.search = this.formParams().toString();
    this.closeDrawer();
    this.navigate(url);
  };

  CollectionGrid.prototype.selectSort = function (value) {
    var url = new URL(location.href);
    if (value) url.searchParams.set("sort_by", value);
    else url.searchParams.delete("sort_by");
    url.searchParams.delete("page");
    this.navigate(url);
  };

  /* On-page filter dropdown → replace just this filter's params */
  CollectionGrid.prototype.dropdownParamNames = function (panel) {
    var names = [];
    panel.querySelectorAll("input[name]").forEach(function (i) {
      if (names.indexOf(i.name) === -1) names.push(i.name);
    });
    return names;
  };

  CollectionGrid.prototype.applyDropdown = function (panel) {
    var url = new URL(location.href);
    this.dropdownParamNames(panel).forEach(function (name) {
      url.searchParams.delete(name);
    });
    panel
      .querySelectorAll('input[type="checkbox"]:checked')
      .forEach(function (i) {
        url.searchParams.append(i.name, i.value);
      });
    panel.querySelectorAll('input[type="text"]').forEach(function (i) {
      var v = i.value.trim().replace(/,/g, "");
      if (v) url.searchParams.append(i.name, v);
    });
    url.searchParams.delete("page");
    this.navigate(url);
  };

  CollectionGrid.prototype.clearDropdown = function (panel) {
    var url = new URL(location.href);
    this.dropdownParamNames(panel).forEach(function (name) {
      url.searchParams.delete(name);
    });
    url.searchParams.delete("page");
    this.navigate(url);
  };

  CollectionGrid.prototype.clearAll = function () {
    var url = this.baseURL();
    var sort = this.currentSort();
    if (sort) url.searchParams.set("sort_by", sort);
    this.closeDrawer();
    this.navigate(url);
  };

  CollectionGrid.prototype.loadMore = function () {
    var btn = this.q("[data-cg-load-more]");
    if (!btn || this.loading) return;
    var nextUrl = btn.getAttribute("data-cg-next-url");
    if (!nextUrl) return;
    this.render(new URL(nextUrl, location.origin), {
      append: true,
      trigger: btn,
    });
  };

  /* --- Fetch + swap --------------------------------------- */
  CollectionGrid.prototype.render = function (url, opts) {
    opts = opts || {};
    var self = this;
    this.loading = true;

    var grid = this.q("[data-cg-grid]");
    if (grid && !opts.append) grid.classList.add("is-loading");
    if (opts.trigger) opts.trigger.setAttribute("aria-busy", "true");

    var fetchUrl = new URL(url.toString());
    fetchUrl.searchParams.set("section_id", this.sectionId);

    fetch(fetchUrl.toString(), {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    })
      .then(function (r) {
        if (!r.ok) throw new Error("Request failed: " + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newRoot = doc.querySelector("[data-collection-grid]");
        if (!newRoot) throw new Error("Section markup not found in response");
        if (opts.append) self.appendResults(newRoot);
        else self.replaceResults(newRoot);
      })
      .catch(function (err) {
        if (window.console) console.error("[collection-grid]", err);
        window.location.assign(url.toString());
      })
      .finally(function () {
        self.loading = false;
        var g = self.q("[data-cg-grid]");
        if (g) g.classList.remove("is-loading");
        var t = self.q("[data-cg-load-more]");
        if (t) t.removeAttribute("aria-busy");
      });
  };

  CollectionGrid.prototype.appendResults = function (newRoot) {
    var grid = this.q("[data-cg-grid]");
    var newGrid = newRoot.querySelector("[data-cg-grid]");
    if (grid && newGrid) {
      var frag = document.createDocumentFragment();
      newGrid.querySelectorAll(".pg-card").forEach(function (card) {
        frag.appendChild(card);
      });
      grid.appendChild(frag);
    }

    var moreWrap = this.q(".cg-more");
    var newMoreBtn = newRoot.querySelector("[data-cg-load-more]");
    var currentBtn = this.q("[data-cg-load-more]");
    if (newMoreBtn && currentBtn) {
      currentBtn.setAttribute(
        "data-cg-next-url",
        newMoreBtn.getAttribute("data-cg-next-url")
      );
    } else if (moreWrap) {
      moreWrap.remove();
    }

    this.initHearts();
  };

  CollectionGrid.prototype.replaceResults = function (newRoot) {
    var scrollY = window.pageYOffset;

    var inner = this.root.querySelector(".pg-inner");
    var newInner = newRoot.querySelector(".pg-inner");
    if (inner && newInner) inner.replaceWith(newInner);

    var drawer = this.root.querySelector("[data-cg-drawer]");
    var newDrawer = newRoot.querySelector("[data-cg-drawer]");
    if (drawer && newDrawer) drawer.replaceWith(newDrawer);
    else if (drawer && !newDrawer) drawer.remove();
    else if (!drawer && newDrawer) this.root.appendChild(newDrawer);

    document.documentElement.style.overflow = "";
    this.bind();

    /* Keep the viewport where it was; if the grid shrank above the fold,
       nudge back so the toolbar stays visible. */
    var maxTop = this.root.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo(0, Math.min(scrollY, Math.max(maxTop - 12, 0)) || scrollY);
  };

  CollectionGrid.prototype.destroy = function () {
    document.removeEventListener("click", this._onDocClick);
    document.removeEventListener("keydown", this._onDocKey);
  };

  /* --- Init ----------------------------------------------- */
  function initAll(scope) {
    (scope || document)
      .querySelectorAll("[data-collection-grid]")
      .forEach(function (root) {
        if (root.dataset.cgInit) return;
        root.dataset.cgInit = "1";
        new CollectionGrid(root);
      });
  }

  window.addEventListener("popstate", function () {
    document
      .querySelectorAll("[data-collection-grid]")
      .forEach(function (root) {
        if (root.__cg) root.__cg.render(new URL(location.href));
      });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });

  document.addEventListener("shopify:section:unload", function (e) {
    var root =
      e.target && e.target.querySelector
        ? e.target.querySelector("[data-collection-grid]")
        : null;
    if (root && root.__cg) root.__cg.destroy();
  });
})();
